export default "__VITE_ASSET__DpVQlYtd__"